import React from 'react'
import {SidebarContainer, Icon, CloseIcon, SidebarMenu, SidebarLink, SidebarRoute, SideBtnWrap} from './SidebarElements';
//import { Link } from 'react-router-dom';
//import {NavHashLink as Link} from 'react-router-hash-link';
import {Link} from 'react-scroll';

const Sidebar = ({isOpen, toggle}) => {
    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarMenu>
                <SidebarLink><Link activeClass="active" to="home" spy={true}> Home</Link></SidebarLink>
                <SidebarLink><Link  to="about" spy={true} smooth={true}>About</Link></SidebarLink>
                <SidebarLink><Link  to="projects" spy={true} smooth={true}>Projects</Link></SidebarLink>
            </SidebarMenu> 
            <SideBtnWrap>
            <Link  to="contact" spy={true} smooth={true}><SidebarRoute>Contact</SidebarRoute></Link>    
            </SideBtnWrap>    
        </SidebarContainer>
    )
}

export default Sidebar